/**
 * Volume plus: the speaker body with a plus beside it — turn the sound up.
 *
 * Progress swells the plus slightly and settles it back, so the motion says the
 * same thing the sign does. See VolumeSignBase for the drawing and the pulse.
 *
 * Color slots: 0 the speaker, 1 the plus.
 */import*as React from"react";import VolumeSign from"web/shared/icons/glyphs/VolumeSignBase";import{jsx as _jsx}from"react/jsx-runtime";// How far the plus swells at the peak of the pulse.
const SCALE_AT_PEAK=1.18;function VolumePlusGlyph(props){return/*#__PURE__*/_jsx(VolumeSign,{vertical:true,scaleAtPeak:SCALE_AT_PEAK,progress:props.progress,colors:props.colors});}export default VolumePlusGlyph;